/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Faq_A7Inputs */

const en_to_xml_faq_a7 = /** @type {(inputs: To_Xml_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envelopes and namespaces are specific to the service you are calling, and nothing in your JSON indicates which ones to use. The converter produces a clean document body. Wrap it in the envelope and add the namespace declarations your endpoint requires.`)
};

const ko_to_xml_faq_a7 = /** @type {(inputs: To_Xml_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`엔벨로프와 네임스페이스는 호출하는 서비스에 따라 다르고, JSON 안에는 어느 것을 써야 하는지 알려주는 것이 없습니다. 변환기는 깔끔한 문서 본문을 만듭니다. 엔드포인트가 요구하는 엔벨로프로 감싸고 네임스페이스 선언을 추가하세요.`)
};

const ja_to_xml_faq_a7 = /** @type {(inputs: To_Xml_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エンベロープと名前空間は呼び出すサービスごとに異なり、JSON の中にはどれを使うべきか示すものがありません。変換器はきれいな文書本文を作ります。エンドポイントが要求するエンベロープで包み、名前空間宣言を追加してください。`)
};

/**
* | output |
* | --- |
* | "Envelopes and namespaces are specific to the service you are calling, and nothing in your JSON indicates which ones to use. The converter produces a clean do..." |
*
* @param {To_Xml_Faq_A7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_faq_a7 = /** @type {((inputs?: To_Xml_Faq_A7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Faq_A7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_faq_a7(inputs)
	if (locale === "ko") return ko_to_xml_faq_a7(inputs)
	return ja_to_xml_faq_a7(inputs)
});